import { api } from '@/app/api';

/**
 * Sign out: the server revokes the session and returns the identity
 * provider's end-session URL (or null), and the browser goes there so the
 * provider can end its own session too. Not a form post: the content
 * security policy limits form actions to this origin, and the provider is
 * another origin.
 */
export async function signOut(): Promise<void> {
  let target = '/login';
  try {
    const res = await api<{ endSessionUrl: string | null }>('/auth/logout', { method: 'POST', silent401: true });
    target = res.endSessionUrl ?? '/login';
  } catch {
    // The session cookie is gone either way; the login page confirms it.
  }
  window.location.assign(target);
}
